var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotInvoicesX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.28,
    d: "M99.9999 199.999C155.228 199.999 199.999 155.228 199.999 99.9994C199.999 44.7713 155.228 0 99.9999 0C44.7718 0 0.000488281 44.7713 0.000488281 99.9994C0.000488281 155.228 44.7718 199.999 99.9999 199.999Z",
    fill: "#AAB0BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.048 68.0941L43.5711 73.0413H44.0753L48.7554 68.0941L53.2785 73.0413H53.7827L58.4627 68.0941L62.9714 73.0268C62.9981 72.3935 63.9541 47.5898 47.0993 47.5898C40.1988 47.5898 34.2778 52.0907 34.2778 73.0413H34.368L39.048 68.0941Z",
    fill: "#AAB0BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0981 47.5898C52.9045 47.5898 59.5412 52.5671 59.5412 65.8392V144.642C59.5412 156.67 66.5919 162.892 73.6425 162.892H150.371V66.6684C150.371 53.8114 143.32 47.5898 132.537 47.5898H47.0981Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.245 146.53L156.475 141.312L151.538 146.53L146.768 141.312L141.831 146.53L137.061 141.312L132.123 146.53L127.353 141.312L122.416 146.53L117.646 141.312L112.709 146.53L107.938 141.312L103.001 146.53L98.2311 141.312L93.294 146.53L88.3468 141.119H88.1476C88.1476 154.507 81.59 162.891 73.6411 162.891H150.369C164.839 162.891 165.701 145.472 165.722 141.797L161.243 146.532L161.245 146.53Z",
    fill: "#AAB0BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.217 70.4355H71.5747V73.8579H140.217V70.4355Z",
    fill: "#213155"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.217 86.4668H71.5747V89.8892H140.217V86.4668Z",
    fill: "#213155"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140.216 107.725H104.362V111.147H140.216V107.725Z",
    fill: "#213155"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M140.216 122.18H104.362V125.602H140.216V122.18Z",
    fill: "#213155"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9415 170.472C81.5757 170.472 93.4391 158.608 93.4391 143.974C93.4391 129.34 81.5757 117.477 66.9415 117.477C52.3072 117.477 40.4438 129.34 40.4438 143.974C40.4438 158.608 52.3072 170.472 66.9415 170.472Z",
    fill: "#616C88"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0005 134L57.0005 154",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0005 154L57.0005 134",
    stroke: "white",
    strokeWidth: 2.8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotInvoicesX);
export default __webpack_public_path__ + "static/media/NotInvoicesX.d55323788ad201a78286f69221d10b31.svg";
export { ForwardRef as ReactComponent };